import { getPickupTimeString } from './time';
import { isFBB } from './window';

export const orderStates = {
  PENDING: 'PENDING', // Used for individual orders of shared orders
  PENDING_CANCELED: 'PENDING_CANCELED', // Used for shared orders that are being canceled before being placed
  NEW: 'NEW',
  ACCEPTED: 'ACCEPTED',
  READY: 'READY',
  READY_NO_SHOW: 'READY_NO_SHOW',
  PICKED_UP: 'PICKED_UP',
  PICKED_UP_TIMEOUT: 'PICKED_UP_TIMEOUT',
  COMPLETED: 'COMPLETED',
  CANCELED: 'CANCELED',
  CANCELED_STORE: 'CANCELED_STORE',
  CANCELED_USER: 'CANCELED_USER',
  IN_PROGRESS: 'IN_PROGRESS',
  NEW_CONFLICT: 'NEW_CONFLICT',
  PAYMENT_ERROR: 'PAYMENT_ERROR',
};

export const orderStatusWording = {
  NEW: 'Neu',
  ACCEPTED: 'Akzeptiert',
  READY: 'Fertig',
  READY_NO_SHOW: 'Kunde nicht gekommen',
  PICKED_UP: 'Abgeholt',
  PICKED_UP_TIMEOUT: 'Abgeholt (timeout)',
  COMPLETED: 'Abgeschlossen',
  CANCELED: 'Im Terminal storniert',
  CANCELED_USER: 'Kunde storniert',
  CANCELED_STORE: 'Bestellung abgelehnt',
  DELIVERY_IN_PROGRESS: 'Wird geliefert',
  DELIVERY_COMPLETED: 'Ausgeliefert',
  DELIVERY_COMPLETED_TIMEOUT: 'Ausgeliefert (timeout)',
};

export const orderCanceledStates = [
  orderStates.CANCELED_STORE,
  orderStates.CANCELED_USER,
];

const CutleryPreferences = {
  NO_PREFRENCE: 'NO_PREFRENCE',
  WITHOUT_CUTLERY: 'WITHOUT_CUTLERY',
  WITH_CUTLERY: 'WITH_CUTLERY',
};

export function formatOrderInput(basket, user, pickup, { token, source }) {
  const isEatIn = false;
  let cutlery = CutleryPreferences.NO_PREFRENCE;
  if (basket.items.some((item) => item.is_cutlery) || isEatIn) {
    cutlery = CutleryPreferences.WITH_CUTLERY;
  }

  const appliedCoupon = user && (user.active_campaigns || [])[0];
  const campaign_id = appliedCoupon ? appliedCoupon.id : null;

  const NO_FEE_FBB = 'cpg_no_fee_fbb';
  const platform_fee_campaign_id = isFBB ? NO_FEE_FBB : null;

  const payment_type = token ? token.type : source ? source.type : null;

  const order = {
    basket_id: basket.id,
    payment_type,
    payment_token: token ? token.id : null,
    source_id: source ? source.id : null,
    campaign_id,
    platform_fee_campaign_id,
    pickup_time: getPickupTimeString(pickup),
    eat_in: isEatIn,
    cutlery,
    type: pickup.isInstantOrder ? 'INSTANT_ORDER' : 'PRE_ORDER',
  };

  return order;
}
